import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import whatsapp from "../../../src/assets/img/WhatsApp_icon.png";
import loadinggg from "../../assets/img/loading-gif.gif";
// import Referafriend from "../../assets/img/Referafriend.gif";
import { Link } from "react-router-dom";
import {
  Table,
  Button,
  Form,
  Spinner,
  Pagination,
  InputGroup,
} from "react-bootstrap";
// import { FiEye } from "react-icons/fi";
// import { BsPeople } from "react-icons/bs";

export default function RefferReport() {
  const user_id = localStorage.getItem("userid");
  const devid = localStorage.getItem("dev_id");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingReddem, setIsLoadingReeedem] = useState(true);
  const [refData, setRefData] = useState({ ref_code: "", ref_by: "" });
  const [updatedRefercode, setUpdatedRefercode] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadButton, setLoadButton] = useState(false);
  const [error, setError] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [ref_message, setref_message] = useState(null);
  const [activeTab, setActiveTab] = useState("Leave1");
  const [paginate, setpaginate] = useState(1);
  const [pagelength, setpagelength] = useState([]);
  const [loadbuttonshow, setloadbuttonshow] = useState();
  const [users, setUsers] = useState([]);
  const [loading21, setLoading21] = useState(false);
  let active = 2;
  let items = [];
  for (let number = 1; number <= 5; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>,
    );
  }

  const shoot = () => {
    pendingbethistory(selectedValue);
  };
  const [selectedValue, setSelectedValue] = useState("");
  useEffect(() => {
    getProfile();
    pendingbethistory();
  }, []);
  var firstNumbers = [];
  const pendingbethistory = async (tablecode) => {
    const user_id = localStorage.getItem("userid");
    if (tablecode === undefined || !tablecode) {
      tablecode = "all";
    }
    // if (formattedDate === undefined) {
    //   var today = moment().format("DD-MM-YYYY")
    //   formattedDate = today;
    // } else {
    //   formattedDate = moment(formattedDate, "MM/DD/YYYY").format("DD-MM-YYYY");
    // }
    const pagevalue = localStorage.getItem("checkpahe");
    if (pagevalue == 1) {
      var abc = paginate;
    } else {
      var abc = 1;
    }
    const dev_id = localStorage.getItem("dev_id");
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id: user_id,
      // date: formattedDate,
      tbl_code: tablecode,
      page: abc,
      dev_id: dev_id,
      //  page: page,
      // ispaginate: 'pendingbethistory',
    };

    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}manage-commission`,
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    };
    try {
      const response = await axios(config);
      // console.warn("kllllll", response.data.data);
      if (response.data.success === "1") {
        localStorage.setItem("checkpahe", "1");
        const userData = response.data.data;
        setpaginate(response.data.pagination);
        setpagelength(response.data.totalPages);
        var count = paginate * 10;
        setloadbuttonshow(count);
        let merged = firstNumbers.concat(userData);

        if (pagevalue == 1) {
          let mer = users.concat(userData);
          setUsers(mer);
        } else {
          let mer = userData;
          setUsers(mer);
        }
      } else {
        let mer = [];
        setUsers(mer);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getProfile = async () => {
    setLoadButton(false);
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id,
      device_id: devid,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      setLoadButton(true);

      if (data.is_login === "0") window.location.href = "/";

      if (data.success === "1") {
        setApiResponse(data.is_bonus);
        setref_message(data.ref_message);
        setRefData({ ref_code: data.ref_code, ref_by: data.ref_by });
        setShowButton(!data.ref_by); // Show button only if ref_by is empty
      } else {
        console.error("API Error:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateReferCode = async (event) => {
    event.preventDefault();
    setLoadingButton(true);

    const requestData = { user_id, ref_by: updatedRefercode };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_NODE}user-update-reffercode`,
        requestData,
        { headers: { "Content-Type": "application/json" } },
      );

      if (response.data.success === "1") {
        Swal.fire(
          "Success",
          "Your refer code has been updated successfully!",
          "success",
        );
        getProfile(); // Refresh the refer code
        setUpdatedRefercode(""); // Clear the input
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      console.error("Error updating refer code:", error);
      Swal.fire(
        "Error",
        "An error occurred while updating the refer code. Please try again.",
        "error",
      );
    } finally {
      setLoadingButton(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText("https://ranabhaimatka.com/?reffercode=" + refData.ref_code)
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Link has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };
  const copyToClipboard1 = () => {
    navigator.clipboard
      .writeText(refData.ref_code)
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Code has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  return (
    <div className="bg-white height-100 overflow-hidden">
      {isLoading ? (
        <div className="spinner_wrappers  ">
          <Spinner animation="border " />
        </div>
      ) : (
        <>
          <section id="Help" className="margin-bottom-88 height_auto">
            <div className="container">
              <div className="row">
                <div className="col-md-6 offset-md-3 col-12">
                  {/* <div className="w-50 mx-auto referfriend">
                    <img src={Referafriend} className="img-fluid" />
                  </div> */}
                  <div className="referalcode">
                    {ref_message}
                    {/* आप अपने REFERAL CODE से जितने भी खिलाड़ी जोड़ोगे, उनकी खेली
                    हुई गेम का आपको 10 % मिलेगा। और वो जितने लोगों को जोड़ेंगे
                    अपने REFERAL CODE से, उसका भी आपको 2 से 5 परसेंट मिलेगा। */}
                  </div>
                  <div className="chatsupportdesign">
                    <h4>Reffer Link</h4>
                    <div className="referlinkdesign">
                      <p>
                        Referral Link: https://ranabhaimatka.com/?reffercode=
                        {refData.ref_code}
                      </p>
                      <button
                        className="buttoncopylink"
                        onClick={copyToClipboard}
                      >
                        Copy Link
                      </button>
                      <p>{refData.ref_code}</p>
                      <button
                        className="buttoncopylink"
                        onClick={copyToClipboard1}
                      >
                        Copy Reffer Code
                      </button>

                      <div className="whatsappicon">
                        <Link
                          className="w-100"
                          to={`whatsapp://send?text=गली दिसावर गेम खेलने वाले 
DOWNLOAD करे.....ranabhaimatka.com ऐप क्योंकि इसमें मिलता है आपको सबसे जायदा रेट 10के 980 रुपए और सबसे FAST एंड SAFE PAYMENT
 https://ranabhaimatka.com/?reffercode=${refData.ref_code}`}
                        >
                          <img src={whatsapp} alt="whatsapp" />
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="bonusreport">
                    <h3>Refer And Earn</h3>
                  </div>
                  <div className="marquee_bonus"></div>
                  {/* <div className="bonuscommison text-center">
                    Total Commission ₹ {Lavel1Com + Lavel2Com}
                  </div> */}
                </div>
                {/* <div className="col-md-12">
                  <div className="table-responsive">
                    <div className=" table-history referhistory">
                      <Table striped bordered hover className="">
                        <thead>
                          <tr>
                            <th>S.NO</th>
                            <th>Date</th>
                            <th>Market Name</th>
                            <th>Commission Amount</th>
                          </tr>
                        </thead>
                        <tbody className="">
                          {loading21 ? (
                            <div className="loadernew21">
                              <img
                                src={loadinggg}
                                className="px-2 loaderfile"
                                alt="Loading..."
                              />
                            </div>
                          ) : (
                            <>
                              {users && users.length > 0 ? (
                                users.map((user, index) => {
                                  const dateTime = new Date(user.date_time);
                                   return (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{user.date}</td>
                                      <td>{user.market_id}</td>
                                     
                                      <td>{user.amount}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="8">
                                    No data available or something went wrong.
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <br></br>
                    <br></br>
                    {pagelength > loadbuttonshow ? (
                      <div className="d-flex justify-content-center loadmore">
                        <button
                          className="btn btn-primary w-50  mx-auto text-center"
                          onClick={shoot}
                          id="loadmore"
                        >
                          Load More
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div> */}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
